module.exports = __webpack_public_path__ + "media/react-dashboard@md-e66af82931e16b9b3a56938da8254482.jpg";